import type { Filter, FilterDataRadio } from '@/app/common/filters/core/filtersTypes.ts';
import { FilterRadioPill } from '@/app/common/filters/types/radio/FilterRadioPill.ts';
import type { FilterTypeBehaviour } from '@/app/common/filters/types/filterTypeDefinition.ts';
import { isNil } from '@/app/components/search/Utilities.ts';
import {
  filterOptions,
  isOptionSelected,
  withDefaultWhenEmpty,
  withSelectedValues,
} from '@/app/common/filters/core/filterOptionSelection.ts';

const dataOf = (filter: Filter) => filter.data as FilterDataRadio;

export const radioType: FilterTypeBehaviour = {
  // optionChips adds to the selection; a radio holds one value, so a chip replaces it.
  chips: {
    options: filterOptions,
    toggle: (filter, values) => {
      const { options, defaultValue } = dataOf(filter);
      const [value] = values;

      // withDefaultWhenEmpty covers a value the list no longer offers.
      if (!options.some((option) => option.value === value && option.selected))
        return withDefaultWhenEmpty(withSelectedValues(filter, [value]));

      return defaultValue === undefined ? filter : withSelectedValues(filter, [defaultValue]);
    },
  },
  pillLabels: FilterRadioPill,
  serialise: (filter, options) => {
    const data = dataOf(filter);
    const selectedOption = data.options.find((option) => option.selected);
    const sitsOnDefault = !isNil(data.defaultValue) && data.defaultValue === selectedOption?.value;

    if (sitsOnDefault && !options?.writeDefault) return undefined;

    return selectedOption?.value;
  },
  isSelected: (filter) => dataOf(filter).options.some(isOptionSelected),
  resetValue: (filter) => ({
    ...filter,
    data: {
      ...dataOf(filter),
      options: dataOf(filter).options.map((option) => ({ ...option, selected: !!option.isDefault })),
    },
  }),
  selectedOptions: (filter) => dataOf(filter).options.filter(isOptionSelected),
};
